import { IFifDsrUpload } from "store/fif/fifDsrSlice";

const PERSIST_KEY = "fif_dsr_processing";

export const persistProcessingFifDsr = (data: IFifDsrUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting FIF DSR data:", error);
  }
};

export const getPersistedProcessingFifDsr = (): IFifDsrUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving FIF DSR data:", error);
    return {};
  }
};

export const removePersistedProcessingFifDsr = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing FIF DSR data:", error);
  }
};
